import { checkForm } from '../utils/errorHandling';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import template from 'modal/user/forgot-password.j2';

import { clearLoginData, loginCanceled, sendPasswordData, sendForgotPasswordFailure } from '../actions/userActions';

import { submitForgotPasswordSaga } from '../sagas/userSagas';

import {
    debug
} from '../utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';

import {
    launchAsyncCreateUserModal,
    launchAsyncLoginModal
} from '@core/js/utils/asyncLaunchers';

function attachParsley(component, store) {
    debug('modal: attachParsleyForForgotPassword');

    $(component.scopedSelector('.js-forgot-password-form')).parsley().on('field:validated', (e) => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-forgot-password-form'));

        let previousMsgs = {};

        if (store.getState().core.modal.forgotPassword) {
            previousMsgs = store.getState().core.modal.forgotPassword.messages;
        }
        store.dispatch(sendPasswordData(values, msgs, previousMsgs));
    });
}

function firstRender(store) {
    this.render(store, this);
    attachParsley(this, store);
}

function afterCancelAction(store) {
    store.dispatch(loginCanceled());
}

function afterCloseAction(store) {
    store.dispatch(clearLoginData());
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-forgot-password-form'), (e) => {
        e.preventDefault();
        this.attachLoader(store);
        const emailAddress = $(this.scopedSelector('[name="email"]')).val();

        const payload = {
            email: emailAddress
        };

        let res = store.runSaga(submitForgotPasswordSaga, payload).done.then(() => {
            this.removeLoader(store);
        }).catch((err) => {
            this.removeLoader(store);
            store.dispatch(sendForgotPasswordFailure(err));
        });
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-user-login'), (e) => {
        e.preventDefault();
        launchAsyncLoginModal(e, this.name);
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-user-create'), (e) => {
        e.preventDefault();
        launchAsyncCreateUserModal(e, this.name);
    });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        watch: 'core.modal.forgotPassword',
        template: template,
        name: 'modal.forgotPassword',
        replace: 'once',
        afterCancelAction: afterCancelAction,
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        loader: {}
    };
    return generate(config, store, overrides);
}
